import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTabsModule } from '@angular/material/tabs';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { BaseTranslateModule } from '@nx-ahs/base-translate';
import { DbIconComponent } from '@nx-ahs/shared/components';
import { AuthenticationGuardService, AppIdGuardService } from '@nx-ahs/shared/guards';

import { AhsFormlySharedModule, CanDeactivateGuard } from '@nx-ahs/formly/shared';

import { FormlyBuilderComponent } from './components/formly-builder/formly-builder.component';
import { FormlyScriptListComponent } from './components/formly-script-list/formly-script-list.component';
import { JsonBuilderComponent } from './components/formly-builder/components/json-builder/json-builder.component';
import { VanillaJsonEditorComponent } from './components/formly-builder/components/vanilla-json-editor/vanilla-json-editor.component';
import { ToolbarSaveComponent } from './components/formly-builder/components/toolbar-save/toolbar-save.component';
import { ImportFromTripettoDialogComponent } from './components/formly-builder/components/import-from-tripetto-dialog/import-from-tripetto-dialog.component';
import { ConversionWarningsComponent } from './components/formly-builder/components/import-from-tripetto-dialog/components/conversion-warnings/conversion-warnings.component';
import { FormlyTranslationsDialogComponent } from './components/formly-builder/dialogs/formly-translations-dialog/formly-translations-dialog.component';
import { VisualBuilderComponent } from './components/visual-builder/visual-builder.component';
import { FieldPaletteComponent } from './components/visual-builder/field-palette/field-palette.component';
import { BuilderCanvasComponent } from './components/visual-builder/builder-canvas/builder-canvas.component';
import { FieldPropertiesPanelComponent } from './components/visual-builder/field-properties-panel/field-properties-panel.component';
import { FieldCardComponent } from './components/visual-builder/field-card/field-card.component';
import { AddFieldDialogComponent } from './components/visual-builder/add-field-dialog/add-field-dialog.component';
import { FlowChartComponent } from './components/visual-builder/flow-chart/flow-chart.component';

const routes: Routes = [
	{
		path: 'builder/:scriptId',
		component: FormlyBuilderComponent,
		canActivate: [AuthenticationGuardService, AppIdGuardService],
		canDeactivate: [CanDeactivateGuard],
		data: { ignoreMenu: true, isAHSOnly: true, isDevOnly: true }
	},
	{
		path: 'list',
		component: FormlyScriptListComponent,
		canActivate: [AuthenticationGuardService, AppIdGuardService],
		data: { ignoreMenu: true, isAHSOnly: true, isDevOnly: true }
	}
];

@NgModule({
	declarations: [
		FormlyBuilderComponent,
		FormlyScriptListComponent,
		JsonBuilderComponent,
		VanillaJsonEditorComponent,
		ToolbarSaveComponent,
		ImportFromTripettoDialogComponent,
		ConversionWarningsComponent,
		FormlyTranslationsDialogComponent,
		VisualBuilderComponent,
		FieldPaletteComponent,
		BuilderCanvasComponent,
		FieldPropertiesPanelComponent,
		FieldCardComponent,
		AddFieldDialogComponent,
		FlowChartComponent
	],
	exports: [FormlyBuilderComponent, FormlyScriptListComponent],
	imports: [
		CommonModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		AhsFormlySharedModule,
		MatButtonModule,
		MatToolbarModule,
		MatCardModule,
		MatExpansionModule,
		MatFormFieldModule,
		MatInputModule,
		MatOptionModule,
		MatSelectModule,
		MatProgressSpinnerModule,
		MatDialogModule,
		MatMenuModule,
		MatTooltipModule,
		MatCheckboxModule,
		MatAutocompleteModule,
		MatIconModule,
		MatPaginatorModule,
		MatSnackBarModule,
		MatTableModule,
		MatButtonToggleModule,
		MatTabsModule,
		FlexLayoutModule,
		BaseTranslateModule,
		FontAwesomeModule,
		ClipboardModule,
		DragDropModule,
		DbIconComponent,
		MatListModule,
		MatDividerModule,
		MatChipsModule,
		RouterModule.forChild(routes)
	]
})
export class AhsFormlyBuilderModule {}
